import { Toaster } from "sonner";
import GameApp from "./GameApp";

function App() {
  return (
    <>
      <GameApp />
      <Toaster />
    </>
  );
}

export default App;
